import { s as refineServiceDecorator } from './services2.js';
import { ILayoutService } from 'monaco-editor/esm/vs/platform/layout/browser/layoutService.js';
const IWorkbenchLayoutService = refineServiceDecorator(ILayoutService);
export { IWorkbenchLayoutService as I };
